<template>
    <div class="h-full w-full flex flex-col">
        <InternshipForm mode="create" :get-all-partners="getAllPartners" :get-academic-year-terms="getAcademicYearTerms" @created="$emit('created')" @close="$emit('close')" @view-student-profile="viewStudentProfile" @review="review" />
    </div>
</template>

<script>
import InternshipForm from "./form.vue";
export default {
    name: "internship-create",
    emits: ["created", "close", "view-student-profile", "review"],
    components: { InternshipForm, },
    props: ["getAllPartners", "getAcademicYearTerms"],
    methods: {
        viewStudentProfile(studentId) {
           this.$emit('view-student-profile', studentId);
        },
        review(formData) {
            this.$emit('review', formData);
        }
    },
}
</script>